module.exports = __webpack_public_path__ + "ebbb0f8c8d0686f8c14296c9d8c47c53.svg";